@let url = link();

<div
    class="cursor-pointer p-6 focus-within:inset-ring-4 hover:bg-primary-100 group/item relative bg-primary-50 class.hover:bg-primary-100 dark:bg-primary-400 print:border-primary print:border-2 rounded-2xl overflow-hidden bg-clip-border h-full transition-all duration-300 inset-ring-primary-800">
    <div class="grid grid-cols-[auto_1fr] gap-6 lg:grid-cols-[auto_1fr_auto] items-center lg:gap-6">
        <!-- Check Icon -->
        <big-icon
            [icon]="iconCheck"
            [size]="'w-10'"
            class="fill-primary dark:fill-white" />

        <!-- Arrow Icon -->
        <big-icon
            [icon]="iconArrowRight"
            [size]="'w-5'"
            class="fill-primary dark:fill-white justify-self-end lg:justify-self-auto" />

        <!-- Content -->
        <div class="col-span-2 lg:col-span-1 lg:col-start-2 lg:row-start-1">
            <h6 class="mb-1">{{ title() }}</h6>
            <ng-content></ng-content>
        </div>
    </div>

    <big-ui-link
        [href]="url?.href!"
        [linkClass]="'outline-none absolute inset-0'"
        class="absolute inset-0">
        <span class="sr-only">{{ 'Mehr Anzeigen' }}</span>
    </big-ui-link>
</div>
